var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('img',{attrs:{"src":require("@/assets/index/joinParty/dp-lc-bg.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))]),_c('button',{on:{"click":_vm.goBack}},[_vm._v("返回上级")])])
}
var staticRenderFns = []

export { render, staticRenderFns }